import Swal from "sweetalert2";

export const commonService = {
    swalPrompt,
    handleError,
    swalConfirm
  };

function swalPrompt(success, message, header, timeout) {
  let prepareObject = {
    icon: 'success',
    title: header ?? null,
    html: message
  };

  if (!success) {
    prepareObject.icon = 'error';
  }

  if (timeout && typeof timeout == 'number') {
    prepareObject.showConfirmButton = false;
    prepareObject.timer = timeout;
  }

  Swal.fire(prepareObject);
}

function swalConfirm(title, message) {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-light m-3"
    },
    buttonsStyling: false
  });

  return swalWithBootstrapButtons.fire({
    title: title,
    text: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    reverseButtons: true
  }).then((result) => {
    return result.isConfirmed;
  });
}

function handleError(error) {
  swalPrompt(false, error);
}

